var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-cover",class:{
    'v-cover--overlay': _vm.overlay,
    'v-cover--contain': _vm.contain,
    'v-cover--dark': _vm.dark,
  }},[(_vm.image)?_c('div',{ref:"image",staticClass:"v-cover__image",style:({ backgroundImage: ("url('" + _vm.image + "')") })}):_vm._e(),_c('p',{staticClass:"wrapper v-cover__wrapper v-cover__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }